import { LineType } from '@/vue/mixins/enums/LineTypeMixin.js';
import { PriceType } from '@/vue/mixins/enums/PriceType.js';
import { FulfillmentType } from '@/vue/mixins/enums/FulfillmentType.js';
import { addFrontendPropertiesToSingle } from '@/vue/components/dashboard/organisms/TentativeBuilder/store/addFrontendProperties.js';
import {
    TentativeDateArray,
    TentativeDayValueMap,
} from '@/vue/components/dashboard/organisms/TentativeBuilder/mixins/TentativeDateOptions.js';

import { useDate } from '@/composables/useDate.js';
const { parseDate, add } = useDate();

export function createTentativeSection(state, lineType, event, tentativePackage, isCreatingPackage = false) {
    let selectedSection = event.section;
    let selectedWith = event.with;
    let tentativeSection = {
        ...selectedSection,
        title: event.title || selectedSection.title,
        tentativeServices: [],
        line_type: lineType,
    };

    let tentativeConfig = state.modifiedTentativeConfig;
    let isPackage = state.modifiedTentativeConfig.type === 'package';

    if (!isPackage && tentativePackage) {
        tentativeSection.package_grouping_id = tentativePackage.package_grouping_id;
    }

    if (isPackage) {
        tentativeSection.start_date = TentativeDateArray[1];
        tentativeSection.end_date = TentativeDateArray[1];
        if (FulfillmentType.isDateDuration(tentativeSection)) {
            tentativeSection.end_date = TentativeDateArray[2];
        }
        if (FulfillmentType.isDateTimeDuration(tentativeSection)) {
            tentativeSection.start_time = tentativeConfig.parent.default_start;
            tentativeSection.end_time = tentativeConfig.parent.default_end;
        }
    } else if (isCreatingPackage) {
        tentativeSection.start_date = parseDate(
            add(tentativePackage.start_date, TentativeDayValueMap[event.package_section_start_day], 'days'),
            'yyyy-MM-dd'
        );
        tentativeSection.end_date = parseDate(
            add(tentativePackage.start_date, TentativeDayValueMap[event.package_section_end_day], 'days'),
            'yyyy-MM-dd'
        );
        tentativeSection.start_time = event.start_time;
        tentativeSection.end_time = event.end_time;
    } else {
        tentativeSection.start_date = parseDate(tentativeConfig.parent.start_at, 'yyyy-MM-dd');
        tentativeSection.end_date = parseDate(tentativeConfig.parent.start_at, 'yyyy-MM-dd');
        if (FulfillmentType.isDateDuration(tentativeSection)) {
            if (tentativeSection.start_date === tentativeSection.end_date) {
                tentativeSection.end_date = parseDate(add(tentativeConfig.parent.start_at, 1, 'days'), 'yyyy-MM-dd');
            }
        }
        if (FulfillmentType.isDateTimeDuration(tentativeSection)) {
            tentativeSection.start_time = tentativeConfig.parent.start_time || '09:00:00';
            tentativeSection.end_time = tentativeConfig.parent.end_time || '17:00:00';
        }
    }
    addFrontendPropertiesToSingle(tentativeSection);
    if (selectedWith) {
        selectedSection.tentativeServices.forEach((tentativeService) => {
            tentativeService.start_date = tentativeSection.start_date;
            tentativeService.end_date = tentativeSection.end_date;
            if (selectedWith === 'packageProducts' && tentativeService.package_product) {
                createTentativeService(state, lineType, tentativeSection, tentativeService);
            } else if (selectedWith === 'addOnProducts' && !tentativeService.package_product) {
                createTentativeService(state, lineType, tentativeSection, tentativeService);
            }
        });
    }

    if (tentativePackage) {
        tentativePackage.tentativeSections.push(tentativeSection);
    } else {
        state.modifiedTentatives[lineType].push(tentativeSection);
    }
    return tentativeSection;
}

export function createTentativeService(state, lineType, tentativeSection, service, returnMode = false) {
    let tentativeConfig = state.modifiedTentativeConfig;
    let tentativeService = {
        ...service,
        line_type: lineType,
        // Ensure settings object is unique per service instance
        settings: service.settings ? { ...service.settings } : undefined,
    };

    addFrontendPropertiesToSingle(tentativeService);
    // When adding a product into a package set the same grouping id
    if (tentativeSection.package_grouping_id) {
        tentativeService.package_grouping_id = tentativeSection.package_grouping_id;
    }

    if (LineType.isAvailable(tentativeService)) {
        tentativeService.available_days = service.available_days;
    } else {
        tentativeService.quantity = PriceType.isPerPersonBased(tentativeService)
            ? tentativeConfig.parent.participants
            : 1;
    }

    if (!returnMode) {
        tentativeSection.tentativeServices.push(tentativeService);
        return tentativeService;
    } else {
        return tentativeService;
    }
}

export function detachAllServicesRelatedTo(state, tentative) {
    if (!tentative.tentativeService && tentative.tentativeSection) {
        tentative.tentativeSection.tentativeServices.forEach((service) => {
            detachAllServicesRelatedTo(state, { tentativeService: service });
        });
    }

    if (state.modifiedTentatives.packages?.length) {
        // Find all services that are attached to the service
        state.modifiedTentatives.packages.forEach((pkg) => {
            pkg.tentativeSections.forEach((section) => {
                section.tentativeServices.forEach((service) => {
                    if (!service.occurs_in_type || !tentative.tentativeService) {
                        return;
                    }

                    if (service.occurs_in_id === tentative.tentativeService.external_id) {
                        service.occurs_in_type = null;
                        service.occurs_in_id = null;
                    }
                });
            });
        });
    }

    if (state.modifiedTentatives.selected?.length) {
        state.modifiedTentatives.selected.forEach((selectedSection) => {
            selectedSection.tentativeServices.forEach((service) => {
                if (!service.occurs_in_type || !tentative.tentativeService) {
                    return;
                }
                if (service.occurs_in_id === tentative.tentativeService.external_id) {
                    service.occurs_in_type = null;
                    service.occurs_in_id = null;
                }
            });
        });
    }
}
